module.exports = __webpack_public_path__ + "img/btn_home.0227625c.png";